import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
    MenuItem,
    FormControl,
    InputLabel,
    Select
} from "@mui/material";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";

const AddConferenceSessionForm = () => {
    const eventid = localStorage.getItem("eventid");
    const history = useHistory();

    const [formData, setFormData] = useState({
        date: "",
        start_time: "",
        end_time: "",
        category_id: "",
        sessions: [
            { topic: "", speaker_id: "", start_time: "", end_time: "" }
        ]
    });

    const [speakers, setSpeakers] = useState([]);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        axios.get(`/api/conference-speakers?id=${eventid}`).then((res) => {
            if (res.status === 200) {
                setSpeakers(res.data.cpindex);
            }
        });

        axios.get(`/api/conference-session-category-index?id=${eventid}`).then((res) => {
            if (res.status === 200) {
                setCategories(res.data.conferencesessionCategories);
            } else {
                swal("Error", "Check API Something Wrong", "error");
            }
        });
    }, [eventid]);

    const handleMainChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSessionChange = (index, field, value) => {
        const updatedSessions = [...formData.sessions];
        updatedSessions[index][field] = value;
        setFormData((prev) => ({ ...prev, sessions: updatedSessions }));
    };

    const addSessionRow = () => {
        setFormData((prev) => ({
            ...prev,
            sessions: [...prev.sessions, { topic: "", speaker_id: "", start_time: "", end_time: "" }]
        }));
    };

    const removeSessionRow = (index) => {
        const updated = [...formData.sessions];
        updated.splice(index, 1);
        setFormData((prev) => ({ ...prev, sessions: updated }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(`/api/conference-session-store?id=${eventid}`, formData).then((res) => {
            if (res.data.status === 200) {
                swal("Success", "Session added successfully", "success");
                setFormData({
                    date: "",
                    start_time: "",
                    end_time: "",
                    category_id: "",
                    sessions: [{ topic: "", speaker_id: "", start_time: "", end_time: "" }]
                });
                history.push("/admin/conference/sessions-list");
            } else {
                swal("Error", "Failed to add session", "error");
            }
        });
    };

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000' }} style={{ marginTop: '5%' }}>
                <h4>
                    <Button
                        sx={{
                            float: 'right',
                            marginTop: '2%',
                            ":hover": { color: "white" }
                        }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}
                    >
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw' }}>
                    <CardContent>
                        <Typography variant="h5" gutterBottom>
                            Add Conference Session
                        </Typography>
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        name="date"
                                        label="Date"
                                        InputLabelProps={{ shrink: true }}
                                        value={formData.date}
                                        onChange={handleMainChange}
                                        required
                                    />
                                </Grid>

                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        type="time"
                                        name="start_time"
                                        label="Session Start Time"
                                        InputLabelProps={{ shrink: true }}
                                        value={formData.start_time}
                                        onChange={handleMainChange}
                                        required
                                    />
                                </Grid>

                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        type="time"
                                        name="end_time"
                                        label="Session End Time"
                                        InputLabelProps={{ shrink: true }}
                                        value={formData.end_time}
                                        onChange={handleMainChange}
                                        required
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <FormControl fullWidth required>
                                        <InputLabel id="category-label">Session Category</InputLabel>
                                        <Select
                                            labelId="category-label"
                                            name="category_id"
                                            value={formData.category_id}
                                            onChange={handleMainChange}
                                            label="Session Category"
                                        >
                                            {categories.map((cat) => (
                                                <MenuItem key={cat.id} value={cat.id}>
                                                    {cat.conference_session_category_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Dynamic topic + speaker + time fields */}
                                {formData.sessions.map((session, index) => (
                                    <React.Fragment key={index}>
                                        <Grid item xs={3}>
                                            <TextField
                                                fullWidth
                                                label="Topic"
                                                value={session.topic}
                                                onChange={(e) =>
                                                    handleSessionChange(index, "topic", e.target.value)
                                                }
                                                required
                                            />
                                        </Grid>

                                        <Grid item xs={2}>
                                            <TextField
                                                fullWidth
                                                type="time"
                                                label="Topic Start Time"
                                                value={session.start_time}
                                                onChange={(e) =>
                                                    handleSessionChange(index, "start_time", e.target.value)
                                                }
                                                InputLabelProps={{ shrink: true }}
                                                required
                                            />
                                        </Grid>

                                        <Grid item xs={2}>
                                            <TextField
                                                fullWidth
                                                type="time"
                                                label="Topic End Time"
                                                value={session.end_time}
                                                onChange={(e) =>
                                                    handleSessionChange(index, "end_time", e.target.value)
                                                }
                                                InputLabelProps={{ shrink: true }}
                                                required
                                            />
                                        </Grid>

                                        <Grid item xs={3}>
                                            <FormControl fullWidth required>
                                                <InputLabel>Speaker</InputLabel>
                                                <Select
                                                    value={session.speaker_id}
                                                    onChange={(e) =>
                                                        handleSessionChange(index, "speaker_id", e.target.value)
                                                    }
                                                    label="Speaker"
                                                >
                                                    {speakers.map((s) => (
                                                        <MenuItem key={s.id} value={s.id}>
                                                            {s.participant_name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={2}>
                                            {formData.sessions.length > 1 && (
                                                <Button
                                                    onClick={() => removeSessionRow(index)}
                                                    color="error"
                                                    variant="outlined"
                                                >
                                                    Remove
                                                </Button>
                                            )}
                                        </Grid>
                                    </React.Fragment>
                                ))}

                                <Grid item xs={12}>
                                    <Button variant="outlined" onClick={addSessionRow}>
                                        Add More Topic + Speaker + Time
                                    </Button>
                                </Grid>

                                <Grid item xs={12}>
                                    <Button type="submit" variant="contained" color="primary">
                                        Save Session
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
};

export default AddConferenceSessionForm;
